/* eslint-disable no-param-reassign */
import SavedFiltersApi from '@/services/savedFilters';

const state = {
  savedFilters: [],
  selectedFilter: null,
  savedFiltersError: null,
};

const getters = {
  selectedFilter: currentState => currentState.selectedFilter,
  savedFilters: currentState => currentState.savedFilters,
  savedFiltersError: currentState => currentState.savedFiltersError,
};

const actions = {
  async fetchFilters({ commit }) {
    try {
      const filters = await SavedFiltersApi.getSavedReports();
      if (filters.reports.length <= 0) {
        commit('setFilterError', 'Você ainda não salvou nenhum filtro.');
      } else {
        commit('setFilters', filters);
      }
    } catch (error) {
      commit('setFilterError', 'Não foi possível carregar seus filtros, tente novamente.');
    }
  },

  async deleteFilter({ commit }, filter) {
    commit('deleteFilter', filter);
  },

  selectFilter({ commit }, filter) {
    commit('selectFilter', filter);
  },

  deselectFilter({ commit }) {
    commit('deselectFilter');
  },
};

const mutations = {
  setFilters(currentState, filters) {
    currentState.savedFilters = filters.reports.map((filter) => {
      const filterCopy = { ...filter };

      filterCopy.description = filter.desUserSupplierReport;
      filterCopy.value = filter.idtUserSupplierReport.toString();

      return filterCopy;
    });
  },
  selectFilter(currentState, value) {
    currentState.selectedFilter = currentState.savedFilters
      .find(filter => filter.value === value);
  },
  deselectFilter(currentState) {
    currentState.selectedFilter = null;
  },
  setFilterError(currentState, value) {
    currentState.savedFiltersError = value;
  },
  async deleteFilter(currentState, filter) {
    currentState.selectedFilter = null;
    await SavedFiltersApi.deleteFilter(filter.value);
    currentState.savedFilters = currentState.savedFilters
      .filter(deletedFilter => deletedFilter.value !== filter.value);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
